import script from "./PreloaderBase.vue?vue&type=script&setup=true&lang=js"
export * from "./PreloaderBase.vue?vue&type=script&setup=true&lang=js"

import "./PreloaderBase.vue?vue&type=style&index=0&id=893bebcc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-893bebcc"]])

export default __exports__